import axios from "axios"
import { API } from "../../../api/api"

export const getAboutUsOld = () => axios.get(API.url + "/about-us?populate=*").then((res) => res.data.data.attributes)
export const getAboutUs = () => axios.get(API.url + "/about-new?populate=*").then((res) => res.data.data.attributes)
